module.exports = __webpack_public_path__ + "img/reply-all-fill.39cea983.svg";